/** @format */

import angular from 'angular';
import angularMaterial from 'angular-material';
import angularTranslate from 'angular-translate';
import angularMoment from 'angular-moment';
import ngFileUpload from 'ng-file-upload';

import 'tinycolor2';
import 'expose-loader?exposes=tinycolor!tinycolor2';
import 'md-rainbow';
import 'md-rainbow/dist/mdRainbow.css';
import ace from 'brace';
import 'brace/mode/css';
import 'angular-ui-ace';

import { AuctionModelsModule } from 'crowdcomms-js/lib/galabid/auction/models';
import { ComponentsModule } from 'crowdcomms-js/lib/galabid/components';
import { ProjectorModelsModule } from 'crowdcomms-js/lib/galabid/projector/models';
import { HonourRollModelsModule } from 'crowdcomms-js/lib/galabid/honour-roll/models';
import { TaskModule } from 'crowdcomms-js/lib/galabid/task';
import { ToastModule } from 'crowdcomms-js/lib/ui/toast';

import { SharedComponentsModule } from '@galabid-presenter/shared/components';
import { EditToolsDialogsModule } from '../dialogs';

import { GbCustomCssPanelComponent } from './gb-custom-css-panel/gb-custom-css-panel.component';
import { GbEditToolsComponent } from './gb-edit-tools/gb-edit-tools.component.js';
import { GbWidgetEditToolsComponent } from './gb-widget-edit-tools/gb-widget-edit-tools.component.js';
import { GbAddWidgetPanelComponent } from './gb-add-widget-panel/gb-add-widget-panel.component.js';
import { GbBackgroundPanelComponent } from './gb-background-panel/gb-background-panel.component.js';
import { GbEditBaseWidgetComponent } from './gb-edit-base-widget/gb-edit-base-widget.component.js';
import { GbAddTextWidgetComponent } from './gb-add-text-widget/gb-add-text-widget.component.js';
import { GbEditTextWidgetComponent } from './gb-edit-text-widget/gb-edit-text-widget.component.js';
import { GbAddImageWidgetComponent } from './gb-add-image-widget/gb-add-image-widget.component.js';
import { GbEditImageWidgetComponent } from './gb-edit-image-widget/gb-edit-image-widget.component.js';
import { GbAddItemTableWidgetComponent } from './gb-add-item-table-widget/gb-add-item-table-widget.component.js';
import { GbEditItemTableWidgetComponent } from './gb-edit-item-table-widget/gb-edit-item-table-widget.component.js';
import { GbBackgroundWidgetComponent } from './gb-background-widget/gb-background-widget.component.js';
import { GbAddTotalRaisedWidgetComponent } from './gb-add-total-raised-widget/gb-add-total-raised-widget.component.js';
import { GbEditTotalRaisedWidgetComponent } from './gb-edit-total-raised-widget/gb-edit-total-raised-widget.component.js';
import { GbAddNotificationWidgetComponent } from './gb-add-notification-widget/gb-add-notification-widget.component.js';
import { GbEditNotificationWidgetComponent } from './gb-edit-notification-widget/gb-edit-notification-widget.component.js';
import { GbAddRaffleDrawWidgetComponent } from './gb-add-raffle-draw-widget/gb-add-raffle-draw-widget.component.js';
import { GbEditRaffleDrawWidgetComponent } from './gb-edit-raffle-draw-widget/gb-edit-raffle-draw-widget.component.js';
import { GbAddRaffleWinnersWidgetComponent } from './gb-add-raffle-winners-widget/gb-add-raffle-winners-widget.component.js';
import { GbEditRaffleWinnersWidgetComponent } from './gb-edit-raffle-winners-widget/gb-edit-raffle-winners-widget.component.js';
import { GbAddThermometerWidgetComponent } from './gb-add-thermometer-widget/gb-add-thermometer-widget.component.js';
import { GbEditThermometerWidgetComponent } from './gb-edit-thermometer-widget/gb-edit-thermometer-widget.component.js';
import { GbAddCountdownWidgetComponent } from './gb-add-countdown-widget/gb-add-countdown-widget.component.js';
import { GbEditCountdownWidgetComponent } from './gb-edit-countdown-widget/gb-edit-countdown-widget.component.js';
import { GbAddTeamScoringWidgetComponent } from './gb-add-team-scoring-widget/gb-add-team-scoring-widget.component.js';
import { GbEditTeamScoringWidgetComponent } from './gb-edit-team-scoring-widget/gb-edit-team-scoring-widget.component.js';
import { GbTemplatePanelComponent } from './gb-template-panel/gb-template-panel.component.js';
import { GbAddHonourRollWidgetComponent } from './gb-add-honour-roll-widget/gb-add-honour-roll-widget.component.js';
import { GbEditHonourRollWidgetComponent } from './gb-edit-honour-roll/gb-edit-honour-roll-widget.component.js';

export const EditToolsComponentsModule = angular
    .module('galabid-presenter.components.edit-tools.components', [
        angularMaterial,
        angularTranslate,
        angularMoment,
        ngFileUpload,
        'mdRainbow',
        AuctionModelsModule,
        ComponentsModule,
        ProjectorModelsModule,
        HonourRollModelsModule,
        TaskModule,
        ToastModule,
        SharedComponentsModule,
        EditToolsDialogsModule,
        'ui.ace',
    ])
    .constant('moment', require('moment-timezone'))
    .component('gbCustomCssPanel', GbCustomCssPanelComponent)
    .component('gbEditTools', GbEditToolsComponent)
    .component('gbWidgetEditTools', GbWidgetEditToolsComponent)
    .component('gbAddWidgetPanel', GbAddWidgetPanelComponent)
    .component('gbBackgroundPanel', GbBackgroundPanelComponent)
    .component('gbEditBaseWidget', GbEditBaseWidgetComponent)
    .component('gbAddTextWidget', GbAddTextWidgetComponent)
    .component('gbEditTextWidget', GbEditTextWidgetComponent)
    .component('gbAddImageWidget', GbAddImageWidgetComponent)
    .component('gbEditImageWidget', GbEditImageWidgetComponent)
    .component('gbAddItemTableWidget', GbAddItemTableWidgetComponent)
    .component('gbEditItemTableWidget', GbEditItemTableWidgetComponent)
    .component('gbBackgroundWidget', GbBackgroundWidgetComponent)
    .component('gbAddTotalRaisedWidget', GbAddTotalRaisedWidgetComponent)
    .component('gbEditTotalRaisedWidget', GbEditTotalRaisedWidgetComponent)
    .component('gbAddNotificationWidget', GbAddNotificationWidgetComponent)
    .component('gbEditNotificationWidget', GbEditNotificationWidgetComponent)
    .component('gbAddRaffleDrawWidget', GbAddRaffleDrawWidgetComponent)
    .component('gbEditRaffleDrawWidget', GbEditRaffleDrawWidgetComponent)
    .component('gbAddRaffleWinnersWidget', GbAddRaffleWinnersWidgetComponent)
    .component('gbEditRaffleWinnersWidget', GbEditRaffleWinnersWidgetComponent)
    .component('gbAddThermometerWidget', GbAddThermometerWidgetComponent)
    .component('gbEditThermometerWidget', GbEditThermometerWidgetComponent)
    .component('gbAddCountdownWidget', GbAddCountdownWidgetComponent)
    .component('gbEditCountdownWidget', GbEditCountdownWidgetComponent)
    .component('gbAddTeamScoringWidget', GbAddTeamScoringWidgetComponent)
    .component('gbEditTeamScoringWidget', GbEditTeamScoringWidgetComponent)
    .component('gbTemplatePanel', GbTemplatePanelComponent)
    .component('gbAddHonourRollWidget', GbAddHonourRollWidgetComponent)
    .component('gbEditHonourRollWidget', GbEditHonourRollWidgetComponent).name;
